import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { signOut } from "@/lib/auth";
import { FC } from "react";
import { toast } from "sonner";

type UserNotAllowedPageProps = {
  email: string;
};

const UserNotAllowedPage: FC<UserNotAllowedPageProps> = ({ email }) => {
  const handleSignOut = async () => {
    try {
      await signOut();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      toast.error("Error al cerrar sesión", { description: error.message });
    }
  };

  return (
    <div
      id="error-page"
      className="flex h-full flex-col bg-[#262452] text-center"
    >
      <Card className="m-auto max-w-md rounded-3xl p-4">
        <CardHeader>
          <CardTitle className="pt-4">No tienes permisos suficientes</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="mb-2">
            Tu usuario <em>{email}</em> no tiene una empresa asignada, por lo
            que no puedes acceder a esta aplicación.
          </p>
          <p className="mb-2">
            <strong>
              Ponte en contacto con un administrador de Empresa con Gestión
              Sostenible para recibir ayuda.
            </strong>
          </p>
          <Button className="mt-8" onClick={handleSignOut}>
            Cerrar sesión
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default UserNotAllowedPage;
